import { observer } from "mobx-react-lite";
import React, { FunctionComponent, useState } from "react";
import { Alert } from "react-bootstrap";
import AlertWithInfoIcon from "views/common/alertWithInfoIcon/alertWithInfoIcon";
import ReactMarkdown from "react-markdown";

const RejectedFiles: FunctionComponent<{
  files: File[];
  allowedFileTypes: string[];
  translate: (code: string) => string;
}> = observer(({ files, allowedFileTypes, translate }) => {
  const [showFileFormats, setFileFormats] = useState(false);
  if (files.length < 1) {
    return null;
  }

  return (
    <>
      {files.map((file: File, index: number) => (
        <Alert
          key={`${file.name}-${index}`}
          variant="danger"
          className="d-flex justify-content-between align-items-center mb-2 text-shadow-none py-3 font-weight-bold">
          <span className="text-break pr-3">{file.name}</span>
        </Alert>
      ))}
      <AlertWithInfoIcon variant="light">
        <ReactMarkdown
          className="markdown"
          components={{
            a: ({ node, ...props }) => (
              <span className="text-body link-underline" style={{ cursor: "pointer" }} onClick={() => setFileFormats(true)}>
                {props.children}
              </span>
            ),
          }}>
          {translate("documentUploader.unsportedFileTypes")}
        </ReactMarkdown>
        {showFileFormats && (
          <>
            <div className="py-2">{allowedFileTypes.join(", ")}</div>
            <label className="text-body link-underline" style={{ cursor: "pointer" }} onClick={() => setFileFormats(false)}>
              {translate("documentUploader.unsportedFileTypesHide")}
            </label>
          </>
        )}
      </AlertWithInfoIcon>
    </>
  );
});

export default RejectedFiles;
